import { Box, Typography } from "@mui/material";
import React from "react";
import GridGrid from "../puzzles/grid/GridGrid";

/**
 * Non-interactive word-search / hidden-message preview for browse cards.
 * Uses real rows×cols (e.g. 8×8 Mini) — no empty padded cells — and labels the size under the grid.
 */
export default function GridBrowseGridPreview({
    grid,
    filledCoordinates,
    hiddenMessageCells = [],
    gridRows,
    gridCols,
    gridSize: gridSizeProp,
}) {
    if (!Array.isArray(grid) || grid.length === 0) return null;

    const rows = Number(gridRows) > 0
        ? Number(gridRows)
        : grid.length;
    const cols = Number(gridCols) > 0
        ? Number(gridCols)
        : (Array.isArray(grid[0]) && grid[0].length > 0
            ? grid[0].length
            : (gridSizeProp === 9 ? 9 : 12));

    return (
        <Box sx={{ width: "100%", flexShrink: 0 }}>
            <Box
                sx={{
                    width: "100%",
                    aspectRatio: `${cols} / ${rows}`,
                    borderRadius: 1,
                    bgcolor: "#fff",
                    overflow: "hidden",
                    pointerEvents: "none",
                    userSelect: "none",
                    boxSizing: "border-box",
                }}
            >
                <GridGrid
                    grid={grid}
                    words={[]}
                    wordsFound={[]}
                    onWordFound={() => {}}
                    onClearClickedWords={() => {}}
                    onClickedWords={() => {}}
                    gridSize={cols}
                    forceSquareAspect={false}
                    isFullscreen={false}
                    isBoldFont={false}
                    filledCoordinates={filledCoordinates}
                    isHintMode={false}
                    highlightCells={[]}
                    hiddenMessageCells={hiddenMessageCells}
                    cellFontPx={rows <= 8 ? 9 : 8}
                />
            </Box>
            <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                    display: "block",
                    textAlign: "center",
                    mt: 0.5,
                    fontWeight: 600,
                    letterSpacing: "0.04em",
                }}
            >
                {rows === 12 && cols === 12 ? "12×12" : `Mini · ${rows}×${cols}`}
            </Typography>
        </Box>
    );
}
